// Configure the API origin via REACT_APP_SERVER_URL. An empty value keeps
// same-origin deployments working without embedding a host in application code.
export const API_BASE_URL = (process.env.REACT_APP_SERVER_URL || '').replace(/\/$/, '');

/**
 * Media URL helper: converts server-side relative upload paths (/uploads/...)
 * into fully qualified URLs using API_BASE_URL.
 * Supports fallback to publicUrl if the file is a legacy static asset.
 */
export const getMediaUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('blob:') || path.startsWith('data:')) {
    return path;
  }
  // Server uploads
  if (path.startsWith('/uploads')) {
    return `${API_BASE_URL}${path}`;
  }
  if (path.startsWith('uploads/')) {
    return `${API_BASE_URL}/${path}`;
  }
  // Legacy frontend assets
  const publicUrl = process.env.PUBLIC_URL || '';
  if (publicUrl && (path === publicUrl || path.startsWith(`${publicUrl}/`))) return path;
  if (path.startsWith('/')) {
    return `${publicUrl}${path}`;
  }
  return `${publicUrl}/${path}`;
};

/**
 * Public API request helper with error parsing
 */
export async function apiRequest(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
  
  const headers = { ...options.headers };

  // If not FormData, default to application/json
  if (!(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const config = {
    ...options,
    headers
  };

  try {
    const response = await fetch(url, config);
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      const errorMsg = data && data.message ? data.message : `Request failed with status ${response.status}`;
      const error = new Error(errorMsg);
      error.status = response.status;
      error.data = data;
      throw error;
    }

    return data;
  } catch (error) {
    console.error(`API Error on [${url}]:`, error);
    throw error;
  }
}
